import React, { Component } from 'react';
import { Field, FieldArray, reset } from 'redux-form'
import ReactDataGrid from 'react-data-grid';
import { Data, CheckboxEditor } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button} from 'react-bootstrap';
import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
import checkPermission from '../Common/permissions';

class RowRenderer extends Component {

    PropTypes: {
      onDoubleClick: React.PropTypes.func
    };

    render() {
        return (<div onDoubleClick={ ()=>{ this.props.onDoubleClick(this.props.row, this.props.field) } } ><ReactDataGrid.Row ref="row" {...this.props} /></div>)
    }
}

export class PackageTypes extends Component {
  constructor() {
    super();
    this.state = {
      packageTypes: {
        rows: [],
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      }
    }
    this.addPackageType = this.addPackageType.bind(this);
    this.editPackageType = this.editPackageType.bind(this);
    this.deletePackageType = this.deletePackageType.bind(this);
  }

  componentWillMount() {
    this.props.fetchPackageTypes();
  }

  componentWillUnmount() {
    this.props.clearPackageTypeEdited()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.packageTypesFetched && nextProps.packageTypesFetched !== this.props.packageTypesFetched) {
      const { packageTypesFetched } = nextProps;
      let index = 0;
      packageTypesFetched.map((packageType) => {
        packageType.Idx = index++;
      });
      const packageTypes = {...this.state.packageTypes, rows: packageTypesFetched};
      this.setState({ packageTypes });
    }
    if (nextProps.packageTypesEdited && nextProps.packageTypesEdited !== this.props.packageTypesEdited) {
      this.props.fetchPackageTypes();
      const packageTypes = { ...this.state.packageTypes, selectedRows: null };
      this.setState({ packageTypes });
    }
    // alert errors
    if (nextProps.deletePackageTypesError && !this.props.deletePackageTypesError) {
      alert(nextProps.deletePackageTypesError);
    }
    if (nextProps.packageTypeEditError && !this.props.packageTypeEditError) {
      alert(nextProps.packageTypeEditError);
    }
  }

  addPackageType() {
    let rows = [...this.state.packageTypes.rows]
    rows.push({PackageType_id: 0, Name: "", Description: "", Simple: "", Idx: rows.length})
    let packageTypes = { ...this.state.packageTypes, rows }
    this.setState({packageTypes})
  }

  editPackageType() {
    this.props.editPackageType(this.state.packageTypes.rows)
  }

  deletePackageType(event) {
    event.preventDefault();
    let packageType_id = this.state.packageTypes.selectedRows[0].PackageType_id;
    if(packageType_id != 0) {
      this.props.deletePackageType(packageType_id);
      let packageTypes = {...this.state.packageTypes, selectedRows: []};
      this.setState({packageTypes})
    }
    else {
      let rows = [...this.state.packageTypes.rows];
      let index = _.findIndex(rows, {Idx: this.state.packageTypes.selectedRows[0].Idx})
      rows.splice(index, 1);
      let packageTypes = {...this.state.packageTypes, rows, selectedRows: []};
      this.setState({packageTypes})
    }
  }

  render() {
    if (this.props.fetchingPackageTypes && !this.props.packageTypeFetchError) return <Spinner/>
    else if (this.props.packageTypeFetchError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.packageTypeFetchError)}</div></ContentWrapper>
    else {
        // Parameters of the react-data-grid

        const getRows = () => {
            return Data.Selectors.getRows(this.state.packageTypes);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var packageTypes = Object.assign({}, this.state.packageTypes, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState({packageTypes});
        }

        const handleRowUpdated = e => {
          var rows = getRows();
          Object.assign(rows[e.rowIdx], e.updated);
          let packageTypes = {...this.state.packageTypes, rows}
          this.setState({packageTypes})
          this.props.clearPackageTypeEdited()
        }

        const onRowsSelected = (rows) => {
             let newRows = getRows();
             newRows.map(r => {
               r.isSelected = false;
             })
             rows.map (r => {
               newRows[r.rowIdx].isSelected = true;
             });
             let packageTypes = {...this.state.packageTypes, rows: newRows, selectedRows: [rows[0].row]}
             this.setState({packageTypes});
        }

         const onRowsDeselected = (rows) => {
             let newRows = getRows();
             rows.map (r => {
               newRows[r.rowIdx].isSelected = false;
             });
             let packageTypes = {...this.state.packageTypes, rows: newRows, selectedRows: []}
             this.setState({packageTypes});
         }
        // Column difinition

        const columns = [
          {
            key: 'Name',
            name: <div><Translate value="name" /><span className="asteriksReq">*</span></div>,
            resizable: true,
            sortable: true,
            width: 100,
            editable: true,
            // filterRenderer: FilterByStart,
          },
          {
            key: 'Description',
            name: <Translate value="desc"/>,
            resizable: true,
            sortable: true,
            width: 100,
            editable: true,
            // filterRenderer: FilterByStart,
          },
          {
            key: 'Simple',
            name: <div><Translate value="simple"/><span className="asteriksReq">*</span></div>,
            resizable: true,
            sortable: true,
            width: 100,
            editable: true,
          },
        ]
        return (
          <div>
            <ButtonToolbar className="group-management-table-buttons">
              <Button onClick={this.addPackageType} disabled={!checkPermission('add_product_group')}><em className="fa fa-plus"/><Translate value="create"/></Button>
              <Button
                bsStyle="success"
                onClick={this.editPackageType}
                disabled={!checkPermission('change_product_group')}
              >
                <em className="fa fa-save marginRightStyle" /><Translate value="save"/>
              </Button>
                <Button
                  bsStyle="danger"
                  className="buttonStyle"
                  onClick={(event) => { this.deletePackageType(event)}}
                  disabled={!this.state.packageTypes.selectedRows || this.state.packageTypes.selectedRows.length != 1 || !checkPermission('delete_product_group')}
                  ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                </Button>
            </ButtonToolbar>
            <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="PackageTypes-dataGrid1">
                <ReactDataGrid
                    rowRenderer={<RowRenderer onDoubleClick={this.props.selectPackageType} field={this.props.field}/>}
                    rowKey='PackageType_id'
                    rowHeight={25}
                    minHeight={620}
                    enableRowSelect='single'
                    onGridSort={handleGridSort}
                    columns={columns}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    enableCellSelect={true}
                    onRowUpdated={handleRowUpdated}
                    rowSelection={{
                      showCheckbox: true,
                      onRowsSelected: onRowsSelected,
                      onRowsDeselected: onRowsDeselected,
                      selectBy: {
                        isSelectedKey: 'isSelected'
                      }
                    }}
                />
            </div></Col></Row>
            <br/>
            {/* {
              this.props.editingPackageTypes &&
              <div className="alert alert-info package-type-saving-info"><span className=""><Translate value="saving"/></span></div>
            }
            {
              this.props.packageTypesEdited &&
              <div className="alert alert-success package-type-saving-info">
                <span className=""><Translate value="saved" /></span>
              </div>
            }
            {
              this.props.packageTypeEditError &&
              <div className="alert alert-danger package-type-saving-info">
                <span className="">{this.props.packageTypeEditError}</span>
              </div>
            }
            {
              this.props.deletingPackageTypes &&
              <div className="alert alert-info package-type-saving-info"><span className=""><Translate value="deleting"/></span></div>
            }
            {
              this.props.deletePackageTypesSuccess &&
              <div className="alert alert-success package-type-saving-info">
                <span className=""><Translate value="deleted"/></span>
              </div>
            }
            {
              this.props.deletePackageTypesError &&
              <div className="alert alert-danger package-type-saving-info">
                <span className="">{this.props.deletePackageTypesError}</span>
              </div>
            } */}
        </div>
        )
      }
  }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Products/packageTypes.jsx